export default __webpack_public_path__ + "static/lab-ffb720036dd9213aee66555a118d9696.svg";